import WysiwygField from './component';

export default WysiwygField;
